import * as React from 'react';
import { ClickAwayListener, Tooltip, Typography } from '@mui/material';
import IconInfo from '@mui/icons-material/InfoOutlined';
import { makeStyles, withStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            cursor: 'help'
        },
        position: 'relative',
        lineHeight: '10pt',
    },
    flex: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
    }
});

interface Props {
    tooltipValue: string;
    withIcon?: boolean;
    children: React.ReactNode;
}

const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 600,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid black',
    },
}))(Tooltip)

const TableTooltip: React.FC<Props> = ({ tooltipValue, children, withIcon = true }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <HtmlTooltip
                className={classes.root}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={
                    <React.Fragment>
                        <Typography color="inherit" style={{ whiteSpace: 'pre-line' }}>{tooltipValue}</Typography>
                    </React.Fragment>
                }
                arrow={false}
            >
                <div onClick={(e) => handleTooltipOpen()} className={classes.flex}>
                    {children}
                    {withIcon && <IconInfo style={{ position: 'relative', top: '-4px', right: '-4px', fontSize: 14, color: '#666666' }} />}
                </div>
            </HtmlTooltip>
        </ClickAwayListener>
    );
};

export default TableTooltip;
